export const NotificationBadge = ({
  count,
}: {
  count: number;
}): JSX.Element => (
  <div className="w-6 h-6 rounded-full flex flex-row items-center justify-center bg-blue-500 absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
    <p className="text-white text-xs font-bold">{count}</p>
  </div>
);
